import React from "react";
import Header from "../../Sections/Header";
import Footer from "../../Sections/Footer";
import Price from "../../Sections/Price";
import NicheHero from "../../Components/NicheShared/NicheHero";
import NicheFeatures, { Feature } from "../../Components/NicheShared/NicheFeatures";
import NicheSteps from "../../Components/NicheShared/NicheSteps";
import NicheCTA from "../../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../../Components/RevealOnScroll";
import { NavLink } from "../../types/nav";

const LINKS: NavLink[] = [
  { label: "Início",          to: "/hamburgueria#hero" },
  { label: "Funcionalidades", to: "/hamburgueria#features" },
  { label: "Como funciona",   to: "/hamburgueria#steps" },
  { label: "Planos",          to: "/hamburgueria#price" },
];

const FEATURES: Feature[] = [
  {
    icon: "mdi:tune-variant",
    title: "Customização completa",
    description: "Ponto, ingredientes extras e remoções, tudo no chat sem confusão.",
  },
  {
    icon: "mdi:moped-outline",
    title: "Delivery ou retirada",
    description: "Alfred confirma a opção e coleta o endereço automaticamente.",
  },
  {
    icon: "mdi:book-open-outline",
    title: "Cardápio com descrição",
    description: "Apresenta burgers e combos com detalhes que dão água na boca.",
  },
  {
    icon: "mdi:star-outline",
    title: "Avaliação pós-entrega",
    description: "Após a entrega, Alfred pede feedback automaticamente.",
  },
];

const STEPS: string[] = [
  "Cadastre seu cardápio com todas as opções de customização",
  "Cliente monta o pedido completo pelo WhatsApp",
  "Alfred confirma e encaminha para a cozinha",
];

const Hamburgueria: React.FC = () => (
  <>
    <Header links={LINKS} />
    <NicheHero
      id="hero"
      headline={`Hamburguer artesanal, pedido automatizado. <br/> O <span style="color:#E4DA1B;">Alfred</span> cuida do resto.`}
      subheadline="O Alfred recebe pedidos com todas as customizações — ponto, adicionais, retirada ou delivery."
    />
    <RevealOnScroll><NicheFeatures id="features" features={FEATURES} /></RevealOnScroll>
    <RevealOnScroll><NicheSteps id="steps" steps={STEPS} /></RevealOnScroll>
    <RevealOnScroll>
      <NicheFollowUp
        title="Pediu uma vez? O Alfred faz ele pedir de novo."
        subtitle="Follow-ups automáticos para reativar clientes, divulgar novidades e aumentar pedidos recorrentes."
        items={[
          "Reative clientes inativos com promoções do dia",
          "Avise sobre novidades no cardápio automaticamente",
          "Envie combos especiais para quem não pede faz tempo",
        ]}
      />
    </RevealOnScroll>
    <RevealOnScroll><NicheCTA phrase="Menos tempo respondendo mensagem, mais tempo na chapa." /></RevealOnScroll>
    <div id="price">
      <Price />
    </div>
    <Footer />
  </>
);

export default Hamburgueria;
